import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { IRootState } from "../../types/redux/IRootStore";
import { passwordDaysToExpire, passwordShowAlert } from "../../aplUtils/authHelper";

export default function PasswordExpiryAlert() {
    const authRedux = useSelector((state: IRootState) => state.auth);
    const showAlert = passwordShowAlert(authRedux);
    const daysToExpire = passwordDaysToExpire(authRedux);

    if (showAlert)
        return (
            <div
                className="alert alert-danger"
                style={{ position: "absolute", marginLeft: "35%", marginRight: "35%", marginTop: "0%", width: "30%", zIndex: "1000" }}
                role="alert"
                id="password-expiry-alert"
            >
                Your password expires in {daysToExpire} days.
                <span className="float-right">
                    <Link to={"/user/password"}>Change</Link>
                </span>
                {/* <button type="button" className="btn btn-primary float-right mt-0 mb-0 p-1">Change</button> */}
            </div>
        );

    return <div id="password-expiry-alert"></div>;
}
